import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import './model'

// skin
const skin = era.skin('widgets/PartnerProgram/PartnerProgramGoPopup')

PartnerProgramGoPopup.displayName = 'PartnerProgramGoPopup'
export function PartnerProgramGoPopup(): JSX.Element | null {
  return (
    <ui.RenderSkin
      from={skin}
      name='PartnerProgramGoToAppPopuppenOpen'
      key='PartnerProgramGoToAppPopuppenOpen'
    />
  )
}
